export enum RapStatus {
  'None' = 0,
  'Generated' = 1,
  'Generating' = 2
}
